import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { Head } from '../../../src/component'
import { CheckoutPage } from '../../../src/model'
import { EmploymentDetails } from '../../../src/component/EmploymentDetails/EmploymentDetails'
import { useAppRouter } from '../../../src/state'
import { Route } from '../../../src/config/router'

export const EmploymentDetailsPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const pageTitle = t('consumerLending:employmentDetails:title')

  useEffect(() => {
    router.prefetch(Route.APPROVED_CREDIT)
    router.prefetch(Route.INITIATE_BANK_VERIFICATION)
  }, [])

  return (
    <>
      <Head title={pageTitle} />
      <EmploymentDetails />
    </>
  )
}
